import React from 'react';

interface RightBlockProps {
  strokeColor?: string;
  fillColor?: string;
  className?: string;
  preserveAspectRatio?: string;
}

export const RightBlock: React.FC<RightBlockProps> = ({
  strokeColor,
  fillColor,
  className,
  preserveAspectRatio = 'none',
}) => {
  return (
    <svg
      width='805'
      height='359'
      viewBox='0 0 805 359'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      preserveAspectRatio={preserveAspectRatio}
    >
      <g clipPath='url(#clip0_126_282)'>
        <rect x='-12' y='300' width='194' height='60' stroke={strokeColor} />
        <path d='M-94 240H86V300H-94V240Z' stroke={strokeColor} />
        <path d='M182 300H362V360H182V300Z' stroke={strokeColor} />
        <rect x='182' y='180' width='180' height='60' stroke={strokeColor} />
        <rect x='86' y='240' width='180' height='60' stroke={strokeColor} />
        <rect x='362' y='300' width='180' height='60' stroke={strokeColor} />
        <rect x='362' y='180' width='180' height='60' stroke={strokeColor} />
        <rect x='362' y='60' width='180' height='60' fill={fillColor} stroke={strokeColor} />
        <rect x='266' y='240' width='180' height='60' fill={fillColor} stroke={strokeColor} />
        <rect x='266' y='120' width='180' height='60' stroke={strokeColor} />
        <rect x='542' y='300' width='180' height='60' stroke={strokeColor} />
        <rect x='542' y='180' width='180' height='60' stroke={strokeColor} />
        <rect x='542' y='60' width='180' height='60' stroke={strokeColor} />
        <rect x='446' y='240' width='180' height='60' stroke={strokeColor} />
        <rect x='446' y='120' width='180' height='60' stroke={strokeColor} />
        <rect x='722' y='300' width='180' height='60' stroke={strokeColor} />
        <rect x='722' y='180' width='180' height='60' stroke={strokeColor} />
        <rect x='722' y='60' width='180' height='60' stroke={strokeColor} />
        <rect x='626' y='240' width='180' height='60' stroke={strokeColor} />
        <rect x='626' y='120' width='180' height='60' fill={fillColor} stroke={strokeColor} />
        <rect x='626' width='180' height='60' stroke={strokeColor} />
      </g>
      <defs>
        <clipPath id='clip0_126_282'>
          <rect width='805' height='359' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};
